<div
  class="grid gap-1 border-2 p-2"
  style="
    grid-template-areas:
      &quot;fields fields&quot;
      &quot;rows cols&quot;
      &quot;values filters&quot;;
    grid-auto-columns: minmax(0, 50%);
  "
>
  <div style="grid-area: fields">
    <span class="font-semibold">Fields</span>
    <div
      cdkDropList
      id="possibleFieldsList"
      #possibleFieldsList="cdkDropList"
      [cdkDropListData]="possibleFields()"
      [cdkDropListConnectedTo]="[rowsList, colsList, valuesList]"
      (cdkDropListDropped)="drop($event)"
      class="flex max-h-[50vh] min-h-[4rem] flex-col items-start gap-0.5 overflow-x-auto rounded bg-slate-50 p-2 shadow-xs"
    >
      @if (!possibleFields()?.length) {
        <p>No data provided</p>
      }
      @if (possibleFields()?.length) {
        @for (field of possibleFields(); track field) {
          <div cdkDrag>
            <ag-pill [label]="field.label || field.field" />
          </div>
        }
      }
    </div>
  </div>

  <div style="grid-area: rows">
    <span class="font-semibold">Rows</span>
    <div
      id="rowsList"
      cdkDropList
      #rowsList="cdkDropList"
      [cdkDropListData]="rows()"
      [cdkDropListConnectedTo]="[valuesList, colsList]"
      (cdkDropListDropped)="drop($event)"
      class="flex max-h-[20vh] min-h-[4rem] flex-col items-start gap-0.5 rounded bg-slate-50 p-2 shadow-xs"
    >
      @for (row of rows(); track row; let index = $index) {
        <div
          cdkDrag
          (click)="
            index === 0 ? openHeadersOverlay($event.target, row, 'row') : null
          "
        >
          <ag-pill
            [value]="row"
            [label]="row.label || row.field"
            [canRemove]="true"
            (remove)="handleRemoveRowClick($event)"
          />
        </div>
      }
    </div>
  </div>

  <div style="grid-area: cols">
    <span class="font-semibold">Cols</span>
    <div
      id="colsList"
      cdkDropList
      #colsList="cdkDropList"
      [cdkDropListData]="cols()"
      [cdkDropListConnectedTo]="[valuesList, rowsList]"
      (cdkDropListDropped)="drop($event)"
      class="flex max-h-[20vh] min-h-[4rem] flex-col items-start gap-0.5 overflow-x-auto rounded bg-slate-50 p-2 shadow-xs"
    >
      @for (row of cols(); track row; let index = $index) {
        <div
          cdkDrag
          (click)="
            index === 0 ? openHeadersOverlay($event.target, row, 'col') : null
          "
        >
          <ag-pill
            [value]="row"
            [label]="row.label || row.field"
            [canRemove]="true"
            (remove)="handleRemoveColClick($event)"
          />
        </div>
      }
    </div>
  </div>

  <div style="grid-area: values">
    <span class="font-semibold">Values</span>
    <div
      cdkDropList
      id="valuesList"
      #valuesList="cdkDropList"
      cdkDropListOrientation="vertical"
      [cdkDropListData]="values()"
      [cdkDropListConnectedTo]="[rowsList, colsList]"
      (cdkDropListDropped)="drop($event)"
      class="flex max-h-[20vh] min-h-[4rem] flex-col items-start gap-0.5 rounded bg-slate-50 p-2 shadow-xs"
    >
      @for (val of values(); track val) {
        <div cdkDrag (click)="openValuesOverlay($event.target, val)">
          <ag-pill
            [value]="val"
            [label]="val.operator + ' of ' + (val.label || val.field)"
            [canRemove]="true"
            (remove)="handleRemoveValueClick($event)"
          />
        </div>
      }
    </div>
  </div>

  <div style="grid-area: filters">
    <span class="font-semibold">Filters</span>
    <div
      class="flex max-h-[20vh] min-h-[4rem] flex-col items-start gap-0.5 rounded bg-slate-50 p-2 shadow-xs"
    >
      <span class="font-light italic">coming soon</span>
    </div>
  </div>
</div>

<ng-template #valuesPortalContent let-value>
  <div class="w-20 select-none rounded-lg bg-white text-center shadow-xl">
    <ul>
      <li
        class="py-1 hover:bg-slate-100"
        (click)="handleAggregationChanged(value, 'count')"
      >
        Count
      </li>
      <li
        class="py-1 hover:bg-slate-100"
        (click)="handleAggregationChanged(value, 'sum')"
      >
        Sum
      </li>
      <li
        class="py-1 hover:bg-slate-100"
        (click)="handleAggregationChanged(value, 'avg')"
      >
        Avg
      </li>
      <li
        class="rounded-b-lg py-1 hover:bg-slate-100"
        (click)="handleAggregationChanged(value, 'min')"
      >
        Min
      </li>
      <li
        class="rounded-b-lg py-1 hover:bg-slate-100"
        (click)="handleAggregationChanged(value, 'max')"
      >
        Max
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #headersPortalContent let-value let-type="type">
  <div
    class="flex w-20 select-none items-center justify-center rounded-lg bg-white p-1 text-center shadow-xl"
  >
    <label>Total:</label>
    <input
      type="checkbox"
      [checked]="value.total"
      (change)="handleTotalChanged($event, value, type)"
    />
  </div>
</ng-template>
